import Swal from "sweetalert2"

export const errorModal = (error) => {
    Swal.fire({
        icon: 'error',
        title: 'Error...',
        text: error
      })
}
